import { render } from "./FormCreateRequest.vue?vue&type=template&id=3485a8aa&scoped=true"
import script from "./FormCreateRequest.vue?vue&type=script&lang=js"
export * from "./FormCreateRequest.vue?vue&type=script&lang=js"

import "./FormCreateRequest.vue?vue&type=style&index=0&id=3485a8aa&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3485a8aa"]])

export default __exports__